import { useConfiguration } from '../../../../../../store/configurationStore';
import { SignDetectionConfig } from '../../../types';
import { MultiColumnRulesBinaryCategoriesSectionProps } from './types';

export const useMultiColumnRulesBinaryCategoriesSection = (
  props: MultiColumnRulesBinaryCategoriesSectionProps
) => {
  const { sectionId, templateId, instrumentType } = props;
  const { getValidationForSection, updateSignDetection, templates } =
    useConfiguration();

  // Read validation from store
  const validationResult = getValidationForSection(sectionId);

  // Get current sign detection config from store
  const template = templates.find(t => t.id === templateId);
  const instrumentConfig = template?.instrumentConfigs.find(
    c => c.instrumentType === instrumentType
  );
  const section = instrumentConfig?.sections.find(s => s.id === sectionId);
  const signDetectionConfig = section?.config.signDetection || {
    sourceColumn: '',
    negativeCategory: '',
    positiveCategory: '',
  };

  const handleSignDetectionChange = (config: SignDetectionConfig) => {
    updateSignDetection(templateId, instrumentType, sectionId, config);
  };

  return {
    validationResult,
    signDetectionConfig,
    handleSignDetectionChange,
  };
};
